import React from 'react';
import { injectIntl, FormattedMessage } from '../../../util/reactIntl';
import NamedLink from '../../NamedLink/NamedLink';
import css from './InfoBox.module.css';
import SmallPrint from '../SmallPrint/SmallPrint';

export const InfoBox = props => {
  const {
    onClick,
    infoBoxText,
    authorId,
    isOwnListing,
    className,
  } = props;

  const noInfoBoxText = <div className={css.infoBoxText}>
    <FormattedMessage id="OrderPanel.infoBox.detail" />
  </div>

  const profileSettingsLink = <NamedLink
    className={css.editInfoText}
    name="ProfileSettingsPage"
    to={{hash: "#infoBox"}}
  >
    <FormattedMessage id="OrderPanel.infoBox.editInfoText" />
  </NamedLink>

  return (
    <div className={`${css.fullContainer} ${className}`}>
      {isOwnListing ? profileSettingsLink : null}

      <div className={css.setContentDisplay}>
        {infoBoxText ? <div className={css.infoBoxText}>
          {infoBoxText.replace(/\n+/g, '\n')}
        </div> : noInfoBoxText}

        <div className={css.contentHighlight}>
          <SmallPrint
            authorId={authorId}
            rootClassName={css.nameLinkColor}
            onlyLink={true}
            linkMsgId="OrderPanel.infoBox.profileLinkFromBox"
          />
        </div>

        <div className={css.contactLink} onClick={onClick}>
          <FormattedMessage id="OrderPanel.infoBox.contactLink" />
        </div>
      </div>
    </div>
  );
};

export default injectIntl(InfoBox);
